import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { IPolicyDetail, Uni30Quota } from 'src/app/modules/shared/models/policy.model';
import { PREV_movements_form_keys, PREV_titles_form_keys } from '../../pages/policy-detail/policy-detail.constants';
import { IObjectKey } from 'src/app/modules/shared/models/objects';

@Component({
  selector: 'app-policy-patrimonio-movimenti',
  templateUrl: './policy-patrimonio-movimenti.component.html',
  styleUrls: ['./policy-patrimonio-movimenti.component.scss']
})
export class PolicyPatrimonioMovimentiComponent implements OnInit {
  @Input() policyDetail: IPolicyDetail;
  @Input() retrievedQuote: Uni30Quota[]
  @Output() retrieveQuote = new EventEmitter<any>();

  public garanzieTableKeys: IObjectKey[] = [];
  public titoliTableKeys: IObjectKey[] = [];
  public boh;

  ngOnInit(): void {
    this.garanzieTableKeys = PREV_movements_form_keys[0].tableKeys;
    this.titoliTableKeys = PREV_titles_form_keys;
    this.boh = this.policyDetail
  }

  retrieveQuoteService(date) {
    this.retrieveQuote.emit(date);
  }

}
